export default __webpack_public_path__ + "static/iot_2-bb7e30920155597c33559398c0d53792.jpg";